import SectionTitle from "../common/SectionTitle";
import { ShieldCheck, CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";

const LifestyleTrustSection = () => {
  return (
    <section id="lifestyle-trust" className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section Title */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: { opacity: 0, y: 40 },
            visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
          }}
        >
          <SectionTitle
            title="Lifestyle & Trust"
            subtitle="A balanced lifestyle with secure planning and long-term value"
          />
        </motion.div>

        {/* Lifestyle + Trust Grid */}
        <div className="mt-10 grid md:grid-cols-2 gap-6">

          {/* Lifestyle Cards */}
          <motion.div
            className="rounded-2xl p-8 bg-gradient-to-br from-emerald-50 to-teal-50 border border-gray-200 shadow-sm"
            whileHover={{ y: -6, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 200 }}
          >
            <h3 className="font-bold text-2xl mb-4">Lifestyle Promise</h3>
            <div className="grid gap-4">
              {[
                "Peaceful township living",
                "Safety & privacy",
                "Community living & events",
                "Balanced lifestyle with modern amenities"
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-emerald-600 mt-1" />
                  <p className="text-gray-600">{item}</p>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Trust Cards */}
          <motion.div
            className="rounded-2xl p-8 bg-gradient-to-br from-emerald-50 to-teal-50 border border-gray-200 shadow-sm"
            whileHover={{ y: -6, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 200 }}
          >
            <h3 className="font-bold text-2xl mb-4">Trust & Planning</h3>

            <div className="grid gap-4">
              {[
                {
                  title: "Secure & Reliable",
                  desc: "Transparent documentation, planned layouts, and long-term growth potential.",
                  icon: <ShieldCheck className="w-6 h-6 text-emerald-600 mt-1" />
                },
                {
                  title: "Built for Value",
                  desc: "Well-planned infrastructure, value-based investment and community growth.",
                  icon: <CheckCircle2 className="w-6 h-6 text-emerald-600 mt-1" />
                }
              ].map((item, idx) => (
                <div key={idx} className="flex gap-3">
                  {item.icon}
                  <div>
                    <h4 className="font-bold text-lg">{item.title}</h4>
                    <p className="text-gray-600 text-sm mt-1">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default LifestyleTrustSection;
